import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=1cbeef79"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cbeef79')) {
      api.createRecord('1cbeef79', component.options)
    } else {
      api.reload('1cbeef79', component.options)
    }
    module.hot.accept("./Orders.vue?vue&type=template&id=1cbeef79", function () {
      api.rerender('1cbeef79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/Orders.vue"
export default component.exports